<div
  class="Tabs"
  role="tablist"
  [ngClass]="{
    'Tabs--Shadow': pageTabs,
    'Tabs--Breadcrumbs': showAsBreadcrumbs,
    'Tabs--Center': isCenterAligned,
    'Tabs--Absolute': hasTabPositionChanged,
    'Tabs--WithoutBorder': isBorderNotRequired,
    'Tabs--desktop': isChangeTabWithDevices,
  }"
>
  @for (tabLabel of tabLabels; track tabLabel; let i = $index) {
    <div
      class="Tab"
      [ngClass]="{ 'Tab--Active': i === selectedIndex }"
      [attr.id]="'Tab_' + i"
      [attr.data-test-id]="'Tab_' + i"
      role="tab"
      [attr.aria-selected]="i === selectedIndex"
      [attr.aria-controls]="'TabPanel_' + i"
    >
      <div
        class="Tab__Label"
        [ngClass]="{
          'Tab__Label--Centered': isCenterAligned,
          'Tab__Label--Block': isBlockDisplay,
          'Tab__Label--WithoutBorder': isBorderNotRequired,
        }"
        (click)="onSelect(i)"
        (keydown.enter)="onSelect(i)"
        [attr.data-test-id]="'TabLabel_' + i"
        #tabLabelElement
      >
        @if (tabLabel?.icon) {
          <icon
            class="Tab__Icon"
            [ngClass]="{ Tab__LargeIcon: isLargeIcon }"
            [config]="{ size: isLargeIcon ? 'large' : 'medium' }"
            [name]="tabLabel?.icon"
          >
          </icon>
        }
        @if (tabLabel?.text || (tabLabel && !tabLabel?.icon)) {
          <h3
            class="Tab__TitleText"
            [attr.id]="'TabLabelText_' + i"
            [attr.data-test-id]="'TabLabelText_' + i"
            [innerHTML]="tabLabel.text || tabLabel"
          ></h3>
        }
        @if (tabLabel?.pill) {
          <p class="Tab__TitlePill" [attr.data-test-id]="'TabLabelPill_' + i">
            {{ tabLabel.pill }}
          </p>
        }
      </div>
    </div>
  }
</div>

@if (isChangeTabWithDevices) {
  <div role="tablist" class="RadioTabs RadioTabs--mobile">
    @for (tabLabel of tabLabels; track tabLabel; let i = $index) {
      <div
        class="RadioTab"
        [ngClass]="{ 'RadioTab--Active': i === selectedIndex }"
        role="tab"
        [attr.aria-selected]="i === selectedIndex"
        [attr.aria-controls]="'TabPanel_' + i"
      >
        <label
          class="RadioTab__Label"
          (click)="onSelect(i)"
          (keydown.enter)="onSelect(i)"
          [attr.data-test-id]="'RadioTabLabel_' + i"
          [attr.tabindex]="i === selectedIndex ? 0 : -1"
        >
          <input
            class="form-control form-control--radio"
            type="radio"
            name="radioTab"
            [attr.checked]="i === selectedIndex ? true : null"
          />
          <p
            class="RadioTab__TitleText"
            [attr.id]="'TabLabelText_' + i"
            [innerHTML]="tabLabel.text || tabLabel"
          ></p>
        </label>
      </div>
    }
  </div>
}

<div
  class="Tab__Content"
  data-test-id="TabConent"
  role="tabpanel"
  tabindex="0"
  [attr.id]="'TabPanel_' + selectedIndex"
  [attr.aria-labelledby]="'TabLabelText_' + selectedIndex"
>
  <ng-content select="[aboveContent]"></ng-content>

  @if (tabTemplates.length) {
    <ng-container
      *ngTemplateOutlet="tabTemplates[selectedIndex]"
    ></ng-container>
  }

  @if (!tabTemplates.length) {
    <ng-container
      [ngTemplateOutlet]="projectedTemplatesList[selectedIndex]?.template"
    ></ng-container>
  }

  <ng-content select="[belowContent]"></ng-content>
</div>
